<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toctitle"><span class="bold">Contents</span></p>
<p class="tocf"><a href="#/06_Foreword"><em class="italic">Foreword</em></a></p>
<p class="toc1"><a href="#/07_Chapter01">1<span class="spacec">Duty, Honor, Country</span></a></p>
<p class="toc"><span href="#/08_Chapter02" title="Link target outside of Sample">2<span class="spacec">Strike Hold!</span></span></p>
<p class="toc"><span href="#/09_Chapter03" title="Link target outside of Sample">3<span class="spacec">Geronimo!</span></span></p>
<p class="toc"><span href="#/10_Chapter04" title="Link target outside of Sample">4<span class="spacec">Let’s Go!</span></span></p>
<p class="toc"><span href="#/11_Chapter05" title="Link target outside of Sample">5<span class="spacec">H Minus!</span></span></p>
<p class="toc"><span href="#/12_Chapter06" title="Link target outside of Sample">6<span class="spacec">Sky Dragons!</span></span></p>
<p class="toc"><span href="#/13_Chapter07" title="Link target outside of Sample">7<span class="spacec">All the Way!</span></span></p>
<p class="tocf1"><span href="#/14_Appendix01" title="Link target outside of Sample"><em class="italic">Appendix 1: Resume of Service Career</em></span></p>
<p class="tocf"><span href="#/15_Appendix02" title="Link target outside of Sample"><em class="italic">Appendix 2: Commander’s Combat Load Iraq (2005)</em></span></p>
<p class="tocf"><span href="#/16_Acronyms" title="Link target outside of Sample"><em class="italic">Acronyms</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?d1b09e02